export default __webpack_public_path__ + "static/media/chia_smth.f339489a.jpg";